/**
* Brands Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Brands Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'brands-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.brands-content' ).each( function( key, component ) {
        $( component ).find( '.magic-line' ).height( $( component ).find( '.brand-logo' ).first().height() );
        $( component ).find( '.brand-logo' ).on( 'click', function() {
          $( component ).find( '.magic-line' ).css( {
            'top': $( this ).position().top,
            'height': $( this ).height(),
            'background-color': $( this ).attr( 'data-color' ),
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'brands-content', COMPONENT );
} )( app );
